import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  name: ""
};
const deviceNameSlice = createSlice({
  name: "deviceSlice",
  initialState,
  reducers: {
    setDeviceName: (state, action) => {
      state.name = action.payload;
    }
  }
});
export const {
  setDeviceName
} = deviceNameSlice.actions;
export default deviceNameSlice.reducer;